/**
 * Les surfaces des gestes de l'élève dans « Tous mes lives », câblage seul : les feuilles du parent
 * (`<ParentSessionGestures>` : décaler, prévenir d'une absence, signaler un retard, et leur
 * accusé), les boîtes de `useLiveSessionsListState` (la confirmation d'une annulation, son échec),
 * plus les trois de l'élève — le paiement en attente, le « GO ! » refusé et la séance clôturée.
 */
import React from "react"

import { ConfirmDialog } from "../../../../../../design-system"
import { PaymentBlockedDialog } from "../../../../../../design-system/student"
import { ParentSessionGestures } from "../../parent/shared/ParentSessionGestures"
import {
    CLOSED_SESSION_TEXTS,
    JOIN_REFUSAL_TEXTS,
    type useStudentLiveSessionsListState,
} from "./useStudentLiveSessionsListState"

export type StudentLiveSessionsListDialogsProps = ReturnType<typeof useStudentLiveSessionsListState>

export function StudentLiveSessionsListDialogs(props: StudentLiveSessionsListDialogsProps) {
    const { state, actions, menu, gestures } = props
    const { cancelConfirm, feedback } = menu

    return (
        <>
            <ParentSessionGestures {...gestures} />
            <ConfirmDialog
                visible={cancelConfirm != null}
                title={cancelConfirm?.title ?? ""}
                message={cancelConfirm?.message}
                confirmLabel="Oui, annuler"
                cancelLabel="Non"
                danger
                onConfirm={actions.confirmCancel}
                onCancel={actions.closeCancel}
                // Le voile ou le retour ferment sans mesurer : l'ancienne boîte ne mesurait que ses boutons.
                onDismiss={menu.actions.closeCancel}
            />
            <ConfirmDialog
                visible={feedback != null}
                title={feedback?.title ?? ""}
                message={feedback?.message}
                confirmLabel="OK"
                hideCancel
                danger={false}
                onConfirm={menu.actions.closeFeedback}
                onCancel={menu.actions.closeFeedback}
            />
            <ConfirmDialog
                visible={state.joinRefused}
                title={JOIN_REFUSAL_TEXTS.title}
                message={JOIN_REFUSAL_TEXTS.message}
                confirmLabel="OK"
                hideCancel
                danger={false}
                onConfirm={actions.confirmJoinRefusal}
                onCancel={actions.dismissJoinRefusal}
            />
            <ConfirmDialog
                visible={state.closedDialog}
                title={CLOSED_SESSION_TEXTS.title}
                message={CLOSED_SESSION_TEXTS.message}
                confirmLabel="OK"
                hideCancel
                danger={false}
                onConfirm={actions.confirmClosed}
                onCancel={actions.dismissClosed}
            />
            <PaymentBlockedDialog visible={state.paymentDialog} onPay={actions.pay} onClose={actions.closePayment} />
        </>
    )
}
